module.exports = __webpack_public_path__ + "static/media/videofx_involvement.8f61e479.png";